<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <div>
        <el-row>
          <el-col :span="12">
            <el-checkbox v-model="isToSort">拖拽排序</el-checkbox>
          </el-col>
          <el-col :span="12">
            <el-button
              v-if="!isToSort"
              type="primary"
              @click="openPaperTransfer">配置【模块/单元】试卷</el-button>
            {{ msg }}
          </el-col>
        </el-row>
      </div>

      <el-form
        class="dataForm"
        ref="form"
        :model="formParameter"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="" prop="sid">
              <div style="margin: 15px 0"></div>

              <el-tree
                v-show="isToSort"
                :data="sortData"
                node-key="id"
                default-expand-all
                draggable
                :allow-drop="allowDrop"
              >
              </el-tree>

              <tree
                v-show="!isToSort && !showTransfer"
                v-loading="treeLoading"
                ref="permissionTree"
                :items="permissionList"
                :defaultExpandAll="treeExpand"
                :defaultParent="0"
                @nodeClick="treeClick"
              >
                <template v-slot:default="{ node }">
                  <span>
                    {{ node.name }}
                    <el-tag
                      v-if="node.paperCount !== undefined"
                      size="mini"
                      type="info"
                      style="margin-left: 5px"
                    >
                      {{ node.paperCount }}试卷
                    </el-tag>
                  </span>
                </template>
              </tree>

              <!-- 穿梭机组件 -->
              <div v-show="showTransfer" class="transfer-container">
                <div
                  v-if="allPapers.length === 0 && !confirmLoading"
                  class="empty-state"
                >
                  <el-empty description="当前没有可用试卷">
                    <div class="empty-tips">
                      <p>可能的原因：</p>
                      <ul>
                        <li>该模块下尚未创建任何试卷</li>
                        <li>试卷未正确关联到模块</li>
                        <li>试卷状态不可用</li>
                      </ul>
                      
                    </div>
                  </el-empty>
                </div>
                <div v-else>
                  <div class="transfer-header">
                    <h4>试卷分配 - {{ currentNode.name }}</h4>
                    <p>
                      共 {{ allPapers.length }} 份试卷，已选
                      {{ selectedPapers.length }} 份
                    </p>
                  </div>
                  <el-transfer
                    v-model="selectedPapers"
                    :data="allPapers"
                    :titles="['所有试卷', '已选试卷']"
                    :button-texts="['移除', '添加']"
                    filter-placeholder="请输入试卷名称"
                    v-loading="confirmLoading"
                    @change="handleTransferChange"
                   
                    :props="{
                      key: 'key',
                      label: 'label',
                      // disabled: 'disabled',
                    }"
                    ref="paperTransfer"
                  >
                    <span slot-scope="{ option }">{{ option.label }}</span>
                  </el-transfer>
                  
                  <div class="transfer-actions">
                    <el-button type="primary" @click="savePaperSelection"
                      >保存分配</el-button
                    >
                    <el-button @click="closeTransfer">取消</el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled && !showTransfer"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >确 定</el-button
      >
    
      <!-- 添加专门的关闭按钮 -->
      <el-button v-if="showTransfer" @click="closeTransfer()"
        >放弃配置试卷</el-button
      >
      <el-button @click="close">取 消</el-button>
      <el-button
        v-if="isToSort"
        type="primary"
        :loading="confirmLoading"
        @click="toSort()"
        >提交排序</el-button
      >
    </div>
  </popup>
</template>

<script>
import tree from "@/components/tree/tree.vue";
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/edu/course/course.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import updateSubjectPapersApi from "@/api/exams/exampaper/exampaper.js";
import $ from "jquery";

export default {
  name: "edit",
  components: {
    tree,
    popup,
    selectOptionDictionary,
  },
  data() {
    return {
      treeLoading: false,
      treeRef: "permissionTree",
      treeExpand: false,
      permissionList: [],
      currentNode: {},
      permissionTable: [],
      tableLoading: true,
      editParameter: {},
      checkAll: false,
      a: [],
      msg: "",
      // cities: cityOptions,
      isIndeterminate: false,
      formParameterAll: {},
      checkedCities: {},
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      rules: {},
      isToSort: false,
      showTransfer: false,
      sortData: [],
      allPapers: [],
      selectedPapers: [],
      subjectId: null,
      paperTransfer: null,
    };
  },
  methods: {
    allowDrop(draggingNode, dropNode, type) {
      return type !== "inner";
    },
    toSort() {
      let sids = "";
      this.sortData.forEach((v, i) => {
        sids += v.id;
        if (i + 1 < this.sortData.length) {
          sids += ",";
        }
      });

      api.updateOne({ id: this.parameter.id, sid: sids }, (res) => {
        this.init();
      });
    },

    // 打开试卷穿梭机
    openPaperTransfer() {

      if (!this.currentNode || !this.currentNode.id) {
        this.$message.warning("请先选择一个科目或模块");
        return;
      }

      this.showTransfer = true;
      this.subjectId = this.currentNode.id;

      // 确保其他模式关闭
      this.isToSort = false;
      this.loadPaperData();
    },

    // 加载试卷数据
    loadPaperData() {
      // 验证节点选择
      if (!this.currentNode || !this.currentNode.id) {
        this.$message.warning("请先选择一个科目或模块");
        return;
      }

      // 初始化加载状态
      this.showTransfer = true;
      this.subjectId = this.currentNode.id;
      this.confirmLoading = true;

      // 获取模块ID（科目ID的前5位）
      const moduleId = this.subjectId.length >= 5 
        ? this.subjectId.substring(0, 5) 
        : this.subjectId;

      console.log("科目ID:", this.subjectId, "模块ID:", moduleId);

      // 构建请求参数
      const params = {
        subjectId: this.subjectId
      };

      // 调用API获取试卷数据
      api.getPapersBySubject(params, (response) => {
        this.confirmLoading = false;
        console.log("API响应:", response);

        // 处理API响应
        if (response.code === 1000) {
        

          // 提取模块试卷和科目试卷
          const unassigned = response.data.unassigned || [];
          const assignedPapers = response.data.assignedPapers || [];
          
          unassigned.push(...assignedPapers)  

          // 处理所有试卷数据
          this.allPapers = unassigned.map((paper) => ({
            key: paper.id,
            label: `${paper.name} (类型: ${this.getPaperTypeText(paper.type)})`,
            disabled: false,
          }));

          // 处理已选试卷ID
          this.selectedPapers = assignedPapers.map((paper) => paper.id);

          // 响应式更新数据
          //this.$set(this, 'allPapers', this.allPapers);
          this.$set(this, 'selectedPapers', this.selectedPapers);


          // 显示提示信息
          if (this.allPapers.length === 0) {
            this.$message.info("当前模块下没有可用试卷，请先创建试卷");
          } else {
            const modulePapers = this.allPapers;
            const subjectPapers = this.selectedPapers;
            if (subjectPapers.length > 0) {
              this.$message.success(
                `加载成功: 模块下共有${modulePapers.length}个试卷，该科目已分配${subjectPapers.length}个试卷`
              );
            } else {
              this.$message.info(
                `加载成功: 模块下共有${modulePapers.length}个试卷，该科目暂未分配试卷`
              );
            }
          }
        } else {
          this.$message.error(response.msg || "加载试卷数据失败");
        }
      }, (error) => {
        this.confirmLoading = false;
        console.error("加载试卷数据失败:", error);
        this.$message.error("加载试卷数据失败: " + (error.msg || error.message || "未知错误"));
      });
    },

    // 获取试卷类型文本
    getPaperTypeText(type) {
      const typeMap = {
        1: "练习",
        2: "测验",
        3: "考试",
        4: "体验",
      };
      return typeMap[type] || "未知";
    },

    // 保存试卷选择
    savePaperSelection() {
      this.confirmLoading = true;

      // 参数验证
      if (!this.subjectId) {
        this.$message.error("未选择科目或模块，请先选择一个节点");
        this.confirmLoading = false;
        return;
      }

      // 检查是否有重复选择的试卷
      // const uniqueSelectedPapers = [...new Set(this.selectedPapers)];
      // if (uniqueSelectedPapers.length !== this.selectedPapers.length) {
      //   this.$message.warning("检测到重复选择的试卷，系统将自动去重");
      //   this.selectedPapers = uniqueSelectedPapers;
      // }

      // 构建请求参数
      const params = {
        subjectId: this.subjectId,
        paperIds: this.selectedPapers
      };

      console.log("保存试卷参数:", params);

      // 调用API保存试卷分配
      updateSubjectPapersApi.updateSubjectPapers(
        params,
        (response) => {
          this.confirmLoading = false;
          if (response.code === 1000) {
            this.$message.success("试卷分配保存成功");
            this.updatePaperCountInTree();

            // 触发保存成功事件
            this.$emit("updateSubjectPapers", {
              subjectId: this.subjectId,
              paperIds: this.selectedPapers,
            });

            setTimeout(() => {
              this.closeTransfer();
            }, 1500);
          } else {
            this.$message.error(response.msg || "保存试卷失败");
          }
        },
        (error) => {
          this.confirmLoading = false;
          console.error("保存试卷失败:", error);
          this.$message.error(
            "保存试卷失败: " + (error.msg || error.message || "未知错误")
          );
        }
      );
    },

    // 更新树节点上的试卷数量
    updatePaperCountInTree() {
      // 查找当前科目节点并更新试卷数量
      const updateNode = (nodes) => {
        nodes.forEach((node) => {
          if (node.id === this.subjectId) {
            // 更新试卷数量为已选试卷数量
            this.$set(node, "paperCount", this.selectedPapers.length);

            // 如果有父节点，可能也需要更新父节点的信息
            this.$forceUpdate(); // 强制更新视图
          }
          if (node.children && node.children.length > 0) {
            updateNode(node.children);
          }
        });
      };
      updateNode(this.permissionList);
    },

    // 穿梭机过滤方法
    filterMethod(query, item) {
      if (!query) return true;
      return item.label.toLowerCase().includes(query.toLowerCase());
    },

    handleCheckAllChange(val) {
      let array = [];
      for (let j of this.formParameterAll) {
        array.push(j.id);
      }
      this.a = val ? array : [];

      this.checkAll = val ? true : false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.formParameterAll.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.formParameterAll.length;
    },

    //打开弹框
    open(parameter, title, disabled, size) {
      console.log("执行 open 方法");

      // 初始化状态
      this.parameter = parameter;
      this.disabled = disabled;
      this.showTransfer = false; // 确保初始不显示试卷编辑
      this.isToSort = false; // 确保初始不显示拖拽排序
      this.allPapers = []; // 清空试卷列表
      this.selectedPapers = []; // 清空已选试卷
      this.subjectId = null; // 清空科目ID

      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },

    // 关闭弹框并重置所有状态
    close() {
      console.log("执行 close 方法 - 开始关闭流程");

      // 1. 重置所有状态变量
      this.disabled = false;
      this.showTransfer = false;
      this.isToSort = false;
      this.allPapers = [];
      this.selectedPapers = [];
      this.subjectId = null;
      this.currentNode = {};

      // 2. 清空穿梭机搜索输入（如果有）
      if (this.$refs.paperTransfer) {
        this.$refs.paperTransfer.clearQuery();
      }

      // 3. 关闭弹窗
      this.$refs.popup.close();

      // 4. 日志输出，确认流程完成
      console.log("弹窗已关闭，所有状态已重置");
    },

    // 关闭试卷编辑模式
    closeTransfer() {
      console.log("关闭试卷编辑模式");
      
      // 重置试卷编辑相关状态
      this.showTransfer = false;
      this.allPapers = [];
      this.selectedPapers = [];
      this.subjectId = null;
      
      // 重置加载状态
      this.confirmLoading = false;
      
      // 清空当前节点选择
      this.currentNode = {};
      
      // 重置搜索过滤条件
      if (this.$refs.paperTransfer) {
        this.$refs.paperTransfer.clearQuery();
      }
      
      this.$message.info("已退出试卷编辑模式");
    },

    // 处理穿梭机变化
    handleTransferChange(value, direction, movedKeys) {
      console.log("穿梭机变化:", {
        value: value,
        direction: direction,
        movedKeys: movedKeys,
      });

      if (direction === "left") {
        // 从右侧移到左侧（移除试卷）
        //this.$message.info(`已移除 ${movedKeys.length} 份试卷`);
       
      } else if (direction === "right") {
        // 从左侧移到右侧（添加试卷）
        // this.$message.info(`已添加 ${movedKeys.length} 份试卷`);
        this.selectedPapers = value
      }

      // 更新已选试卷数量显示
      this.$message.success(`当前已选 ${this.subjectPapers?this.subjectPapers.length:0} 份试卷`);
    },

    expandTree() {
      this.treeExpand = !this.treeExpand;
      //控制el-tree展开收起
      for (
        var i = 0;
        i < this.$refs.permissionTree.getTree().store._getAllNodes().length;
        i++
      ) {
        this.$refs.permissionTree.getTree().store._getAllNodes()[i].expanded =
          this.treeExpand;
      }
    },
    //点击部门
    treeClick(data) {
      if (this.currentNode == data) {
        this.currentNode = {};
        $(".el-tree-node").removeClass("is-current");
      } else {
        this.currentNode = data;
      }

      if (this.currentNode.name) {
        this.msg =
          this.currentNode.name + " ~~~~ " + this.currentNode.days + "天";
      } else {
        this.msg = " ";
      }

      this.freshTable();
    },
    freshTable() {
      this.tableLoading = true;
      this.permissionTable = [];
      if (this.currentNode.id) {
        for (var d of this.permissionList) {
          if (d.pid == this.currentNode.id) {
            this.permissionTable.push(d);
          }
        }
      } else {
        for (var d of this.permissionList) {
          //根节点
          if (d.pid == 0) {
            this.permissionTable.push(d);
          }
        }
      }
      this.tableLoading = false;
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        if (!this.parameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          this.formParameter.sid = this.a;
          let parameter = this.$utils.merger(this.formParameter);
          api.update2(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清除校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdateSubject2(parameter, (response) => {
          this.permissionList = response.data.subjectsAll;

          this.permissionList.forEach((v) => {
            if (v.pid * 1 == 0) {
              this.sortData.push({ id: v.id, label: v.name });
            }
          });
          this.popupLoading = false;
          this.formParameter.id = this.parameter.id;
        });
      } else {
        api.toSave({}, (response) => {
          this.permissionList = response.data.subjectsAll;
          this.popupLoading = false;
        });
        //添加
        this.popupLoading = false;
      }
    },

    // 初始化试卷数量
    initPaperCount(nodes) {
      const initCount = (nodeList) => {
        nodeList.forEach((node) => {
          // 初始化试卷数量为0
          this.$set(node, "paperCount", 0);

          // 如果有子节点，递归处理
          if (node.children && node.children.length > 0) {
            initCount(node.children);
          }
        });
      };

      initCount(nodes);
    },

    // 去创建试卷的方法（空实现，需要时可完善）
    // gotoCreatePaper() {
    //   this.$message.info("跳转到创建试卷页面");
    // },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
.transfer-container {
  padding: 20px;
}

.transfer-header {
  margin-bottom: 20px;
}

.transfer-header h4 {
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #333;
}

.transfer-header p {
  margin: 0;
  color: #666;
}

.transfer-actions {
  margin-top: 20px;
  text-align: center;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
}

.empty-tips {
  text-align: left;
  max-width: 400px;
  margin: 20px auto 0;
}

.empty-tips p {
  font-weight: bold;
  margin-bottom: 10px;
}

.empty-tips ul {
  text-align: left;
  margin-bottom: 20px;
}

/deep/ .el-transfer-panel {
  width: 350px !important; 
}


</style>